import { render, staticRenderFns } from "./TransportOrderReport.vue?vue&type=template&id=2b73d107&lang=pug"
import script from "./TransportOrderReport.vue?vue&type=script&lang=js"
export * from "./TransportOrderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports